// extracted by mini-css-extract-plugin
export default {"productDescription":"O_-z","featuredDescription":"P_-z","description":"Q_-z","more":"R_-z","descriptionSku":"S_-z"};